import { PricingSection, PricingSectionPriceDetail } from "./PricingSection";
import Link from "next/link";

export default function VirtualSinglePricing() {
  return (
    <PricingSection
      title="Eventive Virtual Single Film"
      description={
        <>
          Launch your film on Eventive. Everything you need for virtual
          distribution of a single title, from DRM-protected screenings to live
          Q&As. Secured by{" "}
          <Link href="/antipiracy">
            <a className="font-medium text-gray-700 hover:underline">
              Eventive Advanced Antipiracy
            </a>
          </Link>
          .
        </>
      }
      includedItems={[
        "Ingest a single title with full DRM protection and forensic watermarking encoded for playout on all devices",
        "Create unlimited screenings with co-branding, unlimited ticket types, discounts, and more",
        "Host live Q&As that are automatically recorded and archived for on-demand viewing",
        "100 free unlocks included for giveaways and screeners ($0.99 per DRM unlock streaming bandwidth fee thereafter)",
        "Promote your film in the Eventive Virtual Catalog",
        "Make your film available for viewing via the web and TV apps",
      ]}
      priceDetail={
        <PricingSectionPriceDetail
          title="One-time fee"
          price="$299"
          priceNote="USD"
          description="Release a single title on the Eventive platform."
          buttonLabel="Launch your film"
          buttonHref="/start?goal=activate&type=filmmaker&activation_type=virtual_single"
        />
      }
    />
  );
}
